export const initialState = {
  items: [],
  isFetching: false,
}

export const setItems = (state, payload) => (
  { ...state, items: payload, isFetching: false }
)

export const setFetchingStatus = (state, payload) => (
  { ...state, isFetching: payload }
)

export const reset = () => initialState
